import './index.css';
import useTheme from '../../utilities/hooks/theme';
import Constants from '../../constants';
import View from '../view';
import Text from '../text';
import React from 'react';
import Avatar from '@mui/material/Avatar/Avatar';

interface Props {
  name: any;
  teamName: any;
  phone: any;
  email: any;
  onPressEditProfile: any;
}

const ProfileInfo = ({
  name = '',
  teamName = '',
  phone = '',
  email = '',
  onPressEditProfile = () => {}
}: Props) => {
  const { ComponentTheme: theme } = useTheme();
  const containerBG = {
    backgroundColor: theme.profileInfoContainer
  };
  const nameTitleColor = {
    color: theme.profileInfoNameTitle
  };
  const mobileTitleColor = {
    color: theme.profileInfoMobileTitle
  };
  const teamNameTitleColor = {
    color: theme.profileInfoTeamNameTitle
  };
  const emailTitleColor = {
    color: theme.profileInfoEmailTitle
  };
  return (
    <View className={'profile-info-container'} style={containerBG}>
      <View className={'profile-info-content-wrapper'}>
        <Avatar sx={{ width: 120, height: 120, borderWidth: 0 }}>
          <Constants.Svgs.ProfileAvatar width={'100%'} height={'100%'} />
        </Avatar>
        <View className={'profile-info-content-item-wrapper'}>
          <View className={'profile-info-name-wrapper'} onPress={onPressEditProfile}>
            <Text className={'profile-info-name'} style={nameTitleColor}>
              {name ? `${name}` : 'Set Name'}
            </Text>
            <Constants.Svgs.Edit width={20} height={20} fill={'#818393'} />
          </View>
          <View
            style={{
              width: '200px',
              height: '1px',
              marginTop: '10px',
              backgroundColor: theme.profileInfoDivider
            }}
          />
          <View
            className={'profile-info-vertical-divider'}
            style={{
              backgroundColor: theme.profileInfoDivider
            }}
          />
          {!teamName.match(/^[0-9a-fA-F]{24}$/) && (
            <Text
              className={'profile-info-team-name'}
              style={teamNameTitleColor}>{`Username : ${teamName}`}</Text>
          )}
          <Text
            className={'profile-info-mobile'}
            style={mobileTitleColor}>{`Mobile No : ${phone}`}</Text>
          {email != null && email.length > 0 && (
            <Text
              className={'profile-info-email'}
              style={emailTitleColor}>{`Email : ${email}`}</Text>
          )}
        </View>
      </View>
    </View>
  );
};
export default React.memo(ProfileInfo);
